import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Beautiful%20anime%20style%20landscape%20with%20cherry%20blossom%20trees%20in%20full%20bloom%20under%20a%20warm%20golden%20sunset%20sky%2C%20soft%20pink%20petals%20floating%20in%20the%20air%2C%20distant%20mountains%20silhouette%2C%20dreamy%20and%20ethereal%20atmosphere%2C%20warm%20coral%20and%20golden%20tones%2C%20cinematic%20composition%2C%20high%20quality%20anime%20background%20art%2C%20clean%20and%20simple%20aesthetic&width=1920&height=1080&seq=hero-bg-home&orientation=landscape"
        alt="樱花动漫-免费手机动漫平台"
        title="樱花动漫-免费手机动漫平台"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4">
        <div className="max-w-3xl">
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl text-white leading-tight mb-4">
            {t('免费动漫随时追番')}
          </h1>
          <p className="text-base md:text-lg text-white/80 mb-6 max-w-xl mx-auto">
            {t('无需下载随时随地畅快追番')}
          </p>
          <p className="text-sm md:text-base text-white/70 mb-8 max-w-lg mx-auto">
            {t('海量动漫资源高清流畅播放')}
          </p>
          <Link
            to="/category/action"
            className="inline-flex items-center gap-2 bg-primary-500/80 backdrop-blur-sm text-white px-8 py-3 rounded-full text-sm font-medium hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap"
          >
            <i className="ri-play-circle-line text-lg"></i>
            {t('立即开始免费观看')}
          </Link>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 pb-6 md:pb-10 text-center z-10">
        <p className="font-heading text-4xl md:text-6xl lg:text-7xl text-white/20 font-bold tracking-wider select-none">
          {t('免费动漫随时追番')}
        </p>
      </div>
    </section>
  );
}